import React from "react";
import { useClientContext } from "contexts/client";

export const featureResolver = (featureList, name) => {
  const feature = featureList.find((feature) => feature.name === name);

  return feature && feature.active;
};

export const featureDetailGetter = (featureList, name) => {
  const feature = featureList.find((feature) => feature.name === name);

  return feature;
};

export const Feature = (props) => {
  const { name, children, ...rest } = props;
  
  const { state: clientState } = useClientContext();
  const featureList = clientState?.client?.featureList;

  const feature = featureDetailGetter(featureList, name);

  if (feature?.active) {
    const childrenWithProps = React.Children.map(children, (child) => {
      // Checking isValidElement is the safe way and avoids a typescript
      // error too.
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { ...rest, label: feature.label });
      }
      return child;
    });

    return childrenWithProps;
    // return children;
  }

  return null;
};

